import React, { useState, useEffect } from "react";
import jsPDF from "jspdf";
import Inputs from "./Inputs"
import "../style/Counter.css";
import clicAdd from "../audios/add.mp3";
import clicRemove from "../audios/remove.mp3";

const Counter = () => {
    
    const [selections, setSelections] = useState(
        JSON.parse(localStorage.getItem("selections")) || []
    );
    const [counters, setCounters] = useState(
        JSON.parse(localStorage.getItem("counters")) || []
    );
    const [genders, setGenders] = useState(
        localStorage.getItem("genders") || ""
    );
    const [colors, setColors] = useState(
        localStorage.getItem("colors") || ""
    );
    const [sizes, setSizes] = useState(
        localStorage.getItem("sizes") || ""
    );

    const soundAdd = new Audio(clicAdd);
    const soundRemove = new Audio(clicRemove);

    const handleClick = (clickSound) => {
    clickSound.play();
    }

    const handleClearStorage = () => {
        localStorage.removeItem("counters");
        localStorage.removeItem("selections");
        setCounters({});
        setSelections([]);
    }

    useEffect(() => {
        localStorage.setItem("genders", genders);
        localStorage.setItem("colors", colors);
        localStorage.setItem("sizes", sizes);
        localStorage.setItem("counters", JSON.stringify(counters));
        localStorage.setItem("selections", JSON.stringify(selections));
        document.getElementById("genders-input").value = genders;
        document.getElementById("colors-input").value = colors;
        document.getElementById("sizes-input").value = sizes;
    }, [genders, colors, sizes, counters, selections]);

    const handleExportPDF = () => {
        const doc = new jsPDF();
        const cDate = new Date();
        const day = cDate.getDate().toString().padStart(2, '0');
        const month = (cDate.getMonth() + 1).toString().padStart(2, '0');
        const year = cDate.getFullYear().toString();
        const currentDate = `${day}-${month}-${year}`;
        doc.text(currentDate, 10, 10);
        doc.text("Mariseta - Suma de camisetas", 10, 20);
    
        const sortedSelections = selections.sort((a, b) => {
            if (a.gender < b.gender) return -1;
            if (a.gender > b.gender) return 1;
            if (a.color < b.color) return -1;
            if (a.color > b.color) return 1;
            if (a.size < b.size) return -1;
            if (a.size > b.size) return 1;
            return 0;
        });
    
        let y = 30;
        let pageCount = 1; 
        sortedSelections.forEach((selection) => {
            const count = counters[`${selection.gender}-${selection.color}-${selection.size}`];
            doc.text(`${selection.gender} ${selection.color} ${selection.size}: ${count}`, 10, y);
            y += 10;

            if (y >= doc.internal.pageSize.height - 10) {
                doc.addPage();
                pageCount++;
                y = 30; 
            }
        });
    
        const total = sortedSelections.reduce((sum, selection) => {
            const count = counters[`${selection.gender}-${selection.color}-${selection.size}`];
            return sum + count;
        }, 0);
        doc.text(`Total de camisetas: ${total}`, 10, y + 10);
    
        doc.save(`suma-de-camisetas-${currentDate}-(${pageCount} paginas).pdf`);
    };
    

    const handleUpdate = () => {
        const gendersInput = document.getElementById("genders-input").value;
        const colorsInput = document.getElementById("colors-input").value;
        const sizesInput = document.getElementById("sizes-input").value;
        setGenders(gendersInput);
        setColors(colorsInput);
        setSizes(sizesInput);
        localStorage.setItem("genders", gendersInput);
        localStorage.setItem("colors", colorsInput);
        localStorage.setItem("sizes", sizesInput);
    };


    const handleAdd = (gender, color, size) => {
        const newSelection = { gender, color, size };
        const existingSelectionIndex = selections.findIndex(
            (s) => s.gender === gender && s.color === color && s.size === size
        );

        if (existingSelectionIndex >= 0) {
            const existingSelection = selections[existingSelectionIndex];
            const key = `${gender}-${color}-${size}`;
            const newCounters = { ...counters, [key]: counters[key] + 1 };
            setCounters(newCounters);

            const newSelections = [...selections];
            newSelections[existingSelectionIndex] = {
                ...existingSelection,
                count: existingSelection.count + 1,
            };
            setSelections(newSelections);
        } else {
            const key = `${gender}-${color}-${size}`;
            const newCounters = { ...counters, [key]: 1 };
            setCounters(newCounters);

            setSelections([...selections, { ...newSelection, count: 1 }]);
        }
        handleClick(soundAdd);
    };

    const handleRemove = (index) => {
        const removedSelection = selections[index];

        const key = `${removedSelection.gender}-${removedSelection.color}-${removedSelection.size}`;
        const newCounters = { ...counters };
        if (newCounters[key] > 1) {
            newCounters[key]--;
        } else {
            delete newCounters[key];
        }
        setCounters(newCounters);

        const newSelections = [...selections];
        newSelections[index] = {
            ...removedSelection,
            count: removedSelection.count - 1,
        };
        if (newSelections[index].count === 0) {
            newSelections.splice(index, 1);
        }
        setSelections(newSelections);
        handleClick(soundRemove);
    };

    return (
        <div class="container">
            <div class="left-container">
                <h2 class="section-title">Contador Mariseta</h2>
                <div class="texts-container">
                    <Inputs />
                    <button class="action-button" onClick={handleUpdate}>Actualizar Textos</button>
                    <button class="action-button" onClick={handleClearStorage}>Nuevo Contador</button>
                    <button class="action-button" onClick={handleExportPDF}>Exportar a PDF</button>
                    <div class="sizes-container">
                        {genders.split(" ").map((gender) =>
                            colors.split(" ").map((color) => (
                                <div key={`${gender}-${color}`} class="selection">
                                    <h4>{`${gender} ${color}`}</h4>
                                    <div class="size-button-container">
                                    {sizes.split(" ").map((size) => (
                                        <button
                                            key={`${gender}-${color}-${size}`}
                                            onClick={() => handleAdd(gender, color, size)}
                                            class="size-button"
                                        >
                                            {size}
                                        </button>
                                    ))}
                                    <br />
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
            <div class="right-container">
                <h2 class="section-title">Suma de camisetas</h2>
                {selections.map((selection, index) => (
                    <div
                        key={`${selection.gender}-${selection.color}-${selection.size}`}
                        class="selection"
                    >
                        {`${selection.gender} ${selection.color} ${selection.size} ${counters[`${selection.gender}-${selection.color}-${selection.size}`]}`}
                        <button
                            onClick={() => handleRemove(index)}
                            class="remove-button"
                        >
                            Restar
                        </button>
                    </div>
                ))}
            </div>
        </div>

    );
};

export default Counter;